import React, { useEffect, useContext } from "react";

import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import { PlayerStateContext, PlayerQueueContext } from "../../../provider";

import View from "./view";

export default () => {
  const [playerState] = useContext(PlayerStateContext);
  const [playerQueue] = useContext(PlayerQueueContext);
  const { isPlaying, currentSongIndex } = playerState;
  const { queue } = playerQueue;

  const handleRemove = async (idx) => {};

  return (
    <View
      queue={queue}
      isPlaying={isPlaying}
      currentSongIndex={currentSongIndex}
    />
  );
};
